// extracted by mini-css-extract-plugin
export default {"answersWrapper":"QuestionTest_answersWrapper__uO3QG"};